import styled from "styled-components";

export const IconWrapper = styled.div<{ expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${({ expanded }) => (expanded ? "" : "rotate(-90deg)")};
  transition: transform 200ms ease;
`;
